import { render, staticRenderFns } from "./PT330QmailParts.vue?vue&type=template&id=0fff8743&scoped=true&"
import script from "./PT330QmailParts.vue?vue&type=script&lang=js&"
export * from "./PT330QmailParts.vue?vue&type=script&lang=js&"
import style0 from "./PT330QmailParts.vue?vue&type=style&index=0&id=0fff8743&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff8743",
  null
  
)

export default component.exports